import { css } from 'styled-components';

const sizes = {
  small: 576,
  medium: 768,
  large: 992,
  extraLarge: 1200
};

const media = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)}
    }
  `;
  return accumulator;
}, {});

export default media;
